import { XmlStatus } from '../types';

const STATUS_RECUSADOS = ['XML INVALIDO', 'DUPLICADO'];

export const isXmlRecusadoNoEnvio = (motivo: string | null | undefined): boolean =>
    !!motivo && STATUS_RECUSADOS.includes(motivo);

export const getXmlStatus = (motivo: string | null | undefined): XmlStatus => {
    if (!motivo || motivo === 'S') return 'processando';
    return 'recusado';
};

export const getXmlRecusaMensagem = (motivo: string | null | undefined): string => {
    switch (motivo) {
        case 'XML INVALIDO':
            return 'O arquivo não é uma NF-e válida.';
        case 'DUPLICADO':
            return 'Esta nota já foi enviada anteriormente.';
        default:
            return 'XML recusado no processamento. Confira a nota e envie novamente.';
    }
};
